import DeleteIcon from "@mui/icons-material/Delete";
import {Chip} from "@mui/material";
import * as React from "react";
import {StatusTitle} from "../../../dictionaries";

/**
 * Чипсы по статусам сделки
 *
 */
export const DraftChip = () => <Chip label={StatusTitle.draft} size="small" deleteIcon={<DeleteIcon/>} sx={{width: '95px'}} variant="filled" color="text.secondary"/>
export const SignedChip = () => <Chip label={StatusTitle.documentsSign} variant="filled" size="small" color="success" sx={{width: '170px'}}/>
export const OnSignChip = () => <Chip label={StatusTitle.documentsOnSign} variant="filled" size="small" color="warning" sx={{width: '190px'}}/>
export const RosreestrQuitanceChip = () => <Chip label={StatusTitle.rosreestrQuitance} variant="filled" size="small" color="error" sx={{width: '190px'}}/>
export const RosreestrPaidChip = () => <Chip label={StatusTitle.rosreestrPaid} variant="filled" size="small" color="info" sx={{width: '95px'}}/>
export const RosreestrValidationErrorChip = () => <Chip label={StatusTitle.rosreestrValidationError} variant="filled" size="small" color="error" sx={{width: '170px'}}/>
export const RosreestrInterruptedChip = () => <Chip label={StatusTitle.rosreestrInterrupted} variant="filled" size="small" color="success" sx={{width: '185px'}}/>
export const RosreestrSuspendedChip = () => <Chip label={StatusTitle.rosreestrSuspended} variant="filled" size="small" color="success" sx={{width: '185px'}}/>
export const DealSentToRRChip = () => <Chip label={StatusTitle.dealSentToRR} variant="filled" size="small" color="info" sx={{width: '175px'}}/>
export const DealCompletedChip = () => <Chip label={StatusTitle.dealCompleted} variant="filled" size="small" color="success" sx={{width: '95px'}}/>
export const XMLReadyChip = () => <Chip label={StatusTitle.XMLReady} variant="filled" size="small" sx={{width: '200px'}} color="success"/>
export const Chips = ({title, color}) => <Chip label={title} size="small" color={color || "success"} sx={{verticalAlign: "baseline"}} variant="filled"/>

export const ErrorSignChip = () => <Chip label="Ошибка" variant="filled" size="small" color="error"/>

/**
 * Возвращает чипс статуса сделки
 * @param status
 * @return {React.JSX.Element|string}
 */
export const getDealStatusChips = (status) => {
  if(!status)
    return <DraftChip></DraftChip>

  if (status === 'rosreestrQuitance') {
    return <RosreestrQuitanceChip/>
  }
  if (status === 'rosreestrPaid') {
    return <RosreestrPaidChip/>
  }

  if (status === 'rosreestrValidationError') {
    return <RosreestrValidationErrorChip/>
  }

  if (status === 'dealCompleted') {
    return <DealCompletedChip/>;
  }

  if (status === 'documentsSign') {
    return <SignedChip/>;
  }

  if (status === 'documentsOnSign') {
    return <OnSignChip/>;
  }

  if (status === 'rosreestrPaid') {
    return <RosreestrPaidChip/>
  }

  if (status === 'rosreestrInterrupted') {
    return <RosreestrInterruptedChip/>
  }

  if (status === 'rosreestrSuspended') {
    return <RosreestrSuspendedChip/>
  }

  if (status === 'dealSentToRR') {
    return <DealSentToRRChip/>
  }

  if (status === 'XMLReady') {
    return <XMLReadyChip/>
  }

  if (status === 'draft') {
    return <DraftChip></DraftChip>
  }

  return '';
}